import React, { useState } from 'react';
import TopBar from '../TopBar';
import agent from "../../agent";
import useTranslation from "../../customHooks/translations";
import InfiniteScroll from "react-infinite-scroller";
import CommonLoader from "../Loaders/CommonLoader";
import { useMediaQuery } from "react-responsive";
import { connect } from "react-redux";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { DEFAULT_GRADIENT } from "../../constants/theme";
import LeaderboardRow from "./LeaderboardRow";

const TopFreaksView = (props) => {
  const translation = useTranslation();
  const [topFreaks, setTopFreaks] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const isDesktop = useMediaQuery({ minWidth: 992 });

  const loadMoreTopFreaks = async (page) => {
    const results = await agent.Freaks.getTopFreaks(page);
    setTopFreaks(prev => [...prev, ...results]);
    if (results.length === 0) setHasMore(false);
  };

  const paddingLeft = isDesktop
    ? (props.leftNavigationOpen ? 300 : 75)
    : 0;

  return (
    <Box sx={{ paddingLeft: `${paddingLeft}px`, minHeight: '100vh', background: 'linear-gradient(180deg, #0d1b2a 0%, #091420 100%)', pb: 12 }}>
      <TopBar />

      {/* Hero header */}
      <Box
        sx={{
          px: { xs: 2, sm: 4 },
          pt: { xs: 2, sm: 3 },
          pb: 3,
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          borderBottom: '1px solid rgba(255,255,255,0.06)',
        }}
      >
        <EmojiEventsIcon sx={{ fontSize: 32, color: '#FFD700' }} />
        <Typography
          variant="h5"
          sx={{
            fontWeight: 800,
            background: DEFAULT_GRADIENT,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          {translation.topFreaks.title}
        </Typography>
      </Box>

      {/* Leaderboard */}
      <Box sx={{ px: { xs: 1, sm: 2, md: 4 }, pt: 2 }}>
        <InfiniteScroll
          pageStart={-1}
          loadMore={loadMoreTopFreaks}
          hasMore={hasMore}
          loader={<CommonLoader key="loader" />}
        >
          {topFreaks.map((item, idx) => (
            <LeaderboardRow key={item.username || idx} item={item} idx={idx} />
          ))}
        </InfiniteScroll>
      </Box>
    </Box>
  );
};

const mapStateToProps = state => ({
  leftNavigationOpen: state.common.leftNavigationOpen,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TopFreaksView);
